import React from "react";
import { Box, Typography } from "@mui/material";
import styled from "styled-components";
import { StyledTextField } from "../FormComponents";

const FormSection = styled.div`
  width: 100%;
  margin-bottom: 24px;
`;

const SectionTitle = styled(Typography)`
  color: #333;
  font-weight: 600;
  margin-bottom: 24px;
  font-family: "Montserrat", sans-serif;
  text-align: center;
`;

const AccountInfoStep = ({ formData, errors, onChange }) => {
  return (
    <FormSection>
      <SectionTitle variant="h6">Account Information</SectionTitle>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 3,
          width: "100%",
        }}
      >
        <StyledTextField
          type="email"
          label="Email Address"
          name="email"
          value={formData.email}
          onChange={onChange}
          required
          error={!!errors.email}
          helperText={errors.email}
          sx={{ width: "100%" }}
        />
        <StyledTextField
          type="text"
          label="Username"
          name="username"
          value={formData.username}
          onChange={onChange}
          required
          error={!!errors.username}
          helperText={errors.username}
          sx={{ width: "100%" }}
        />
      </Box>
    </FormSection>
  );
};

export default AccountInfoStep;
